import { Serializable } from "../util/Serialization";
import { BaseDynamoClass } from "./BaseDynamoClass";

export class LockResult<T extends BaseDynamoClass<any>> implements Serializable {
    _className: string = "LockResult";
    className: string = "LockResult";
    object : T;
    lockKeyOwner : number;
    constructor(object : T, lockKeyOwner : number){
        this.object = object;
        this.lockKeyOwner = lockKeyOwner;
    }
    _deserializeClassName: string = "LockResult";
    getIgnoreFields(): string[] {
        return [];
    }
}